import React, { useRef, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "../../styles/toolTips.css";

const synth = window.speechSynthesis;

export default function HighlighterSpeakerComponent() {
  const speakActive = useRef(false);
  const previusHighlightedText = useRef("");

  useEffect(() => {
    const saveSelection = (e) => {
      // e.preventDefault();
      if (speakActive.current) {
        if (previusHighlightedText.current !== window.getSelection().toString() && window.getSelection().toString() !== "") {
          previusHighlightedText.current = window.getSelection().toString();
          speak(window.getSelection().toString());
        }
      }
    };
    document.addEventListener("mouseup", saveSelection);
    return () => document.removeEventListener("mouseup", saveSelection);
  }, []);

  const speak = (textToSpeech) => {
    if (synth) {
      var utterance = new SpeechSynthesisUtterance(textToSpeech);
      utterance.voice = synth.getVoices()[14]; // Google português do Brasil - lang: pt-BR
      utterance.lang = "pt-BR";
      utterance.pitch = 0.82;
      utterance.rate = 1.2;
      synth.speak(utterance);
    }
  };

  const activateLocaucao = () => {
    speakActive.current = !speakActive.current;
    if (speakActive.current)
      speak("Ativando a locução: ao selecionar um texto, ele será lido em voz alta. Para desativar, clique novamente no botão de locução.");
    document.getElementById("btnLocucao").style.color = speakActive.current ? "rgba(0, 255, 0, 0.85)" : "rgba(255, 255, 255, 0.85)";
  };

  const tooltip = (
    <Tooltip id="tooltip" className="custom-tooltip">
      <div className="d-flex justify-content-top m-0 p-0" style={{ maxWidth: "96px" }}>
        <div className="d-flex justify-content-middle m-0">
          <span className="material-icons pt-1">record_voice_over</span>
        </div>
        <div className="m-0 narrow-tooltip lh-1 text-start">
          <span
            style={{
              fontSize: "9px",
              fontWeight: "450",
            }}
          >
            ACESSÍVEL POR
          </span>
          <br />
          <span
            style={{
              fontSize: "18px",
            }}
          >
            <strong>LOCUÇÃO</strong>
          </span>
        </div>
      </div>
    </Tooltip>
  );

  return (
    <>
      <OverlayTrigger placement="left" overlay={tooltip} delayShow={300} delayHide={150} style={{ zIndex: "10000" }}>
        <button
          id="btnLocucao"
          className="btn btn-light float-end me-2 custom-tooltip"
          style={{
            position: "fixed",
            top: "calc(50% + 24px)",
            right: "2px",
            minWidth: "40px",
            maxWidth: "40px",
            minHeight: "40px",
            maxHeight: "40px",
            color: "rgba(255, 255, 255, 0.85)",
            borderRadius: "8px",
            paddingTop: "6px",
            paddingBottom: "2px",
            paddingLeft: "7px",
            paddingRight: "5px",
            backgroundImage: "linear-gradient(to right, #2c7ce7 0%, #2e7fea 100%)",
            border: "none",
            zIndex: "10000",
          }}
          onClick={activateLocaucao}
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          data-bs-title="Acessivel por locução"
        >
          <span className="material-icons">record_voice_over</span>
        </button>
      </OverlayTrigger>
    </>
  );
}
